export const tableWithToggleRows = () => {
  return [
    {
      content: 'Row 1',
      isVisible: true,
      toggleable: false,
    },
    {
      content: 'Row 2',
      isVisible: false,
      toggleable: true,
    },
    {
      content: 'Row 3',
      isVisible: false,
      toggleable: true,
    },
    {
      content: 'Row 4',
      isVisible: true,
      toggleable: false,
    },
  ];
};

export const tableWithHighlight = () => {
  return [
    {
      content: 'Row 1',
      isVisible: true,
      toggleable: false,
      value: 1,
    },
    {
      content: 'Row 2',
      isVisible: false,
      toggleable: true,
      value: 2,
    },
    {
      content: 'Row 3',
      isVisible: true,
      toggleable: false,
    },
    {
      content: 'Row 4',
      isVisible: true,
      toggleable: false,
    },
  ];
};

export const tableWithFilter = () => {
  return [
    {
      content: 'ABC',
      isVisible: true,
      toggleable: false,
      value: 1,
    },
    {
      content: 'DEF',
      isVisible: true,
      toggleable: false,
    },
    {
      content: 'GHI',
      isVisible: true,
      toggleable: false,
    },
    {
      content: 'KLM',
      isVisible: true,
      toggleable: false,
    },
  ];
};

export const testHelpers = {
  toggle: tableWithToggleRows,
  highlight: tableWithHighlight,
  search: tableWithFilter,
};
